import { DELETE } from "../../API/delete";

export const deleteImage = async ({job_id, image_id}) => {
    const response = await DELETE(`v3/job-images/${job_id}/${image_id}`);
    return response.status === "Success" ? response : null;
}